import React from "react";
import { KTextInput } from "@kyburz/kdesign-system";

import { humanize } from "../../../../utils/utils";
import KSwitch from "../../../../components/ui/button/switch";

type LSVASettingsProps = {
  internals: Record<string, any>;
  setInternals: (v: any) => void;
};

export const LSVASettings = ({
  internals,
  setInternals,
}: LSVASettingsProps) => {
  const handleParameterUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInternals({
      ...internals,
      trailers_detection_parameters: {
        ...internals.trailers_detection_parameters,
        [name]: value ? parseFloat(value) || null : null,
      },
    });
  };
  const handleSmsPerDayUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInternals({
      ...internals,
      [name]: value ? value || null : null,
    });
  };
  const handleValidationToggleUpdate = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { name, checked } = e.target;
    setInternals({
      ...internals,
      [name]: checked,
    });
  };

  const getLabel = (key: string) => {
    switch (key) {
      case "distance":
        return "Distance (km)";
      case "speed":
        return "Speed (km/h)";
      case "ignition_time":
        return "Ignition Time (s)";
      default:
        return humanize(key);
    }
  };

  if (
    !internals?.trailers_detection_parameters ||
    !Object.keys(internals?.trailers_detection_parameters)?.length
  ) {
    return <div>No LSVA settings available</div>;
  }

  return (
    <div>
      <h3>Trailers Detection Parameters</h3>
      {Object.entries(internals?.trailers_detection_parameters).map(
        ([key, value]) => {
          return (
            <KTextInput
              onChange={handleParameterUpdate}
              value={typeof value === "number" ? value : 0}
              type="number"
              label={getLabel(key)}
              name={key}
              key={key}
            />
          );
        },
      )}
      <h3>SMS Parameters</h3>
      <KTextInput
        onChange={handleSmsPerDayUpdate}
        value={internals?.lsva_max_sms_per_vehicle_per_day}
        type="number"
        label="Max SMS per Vehicle per Day"
        name="lsva_max_sms_per_vehicle_per_day"
      />
      <h3>Validation</h3>
      <KSwitch
        name="lsva_validate_phone_and_language"
        onChange={handleValidationToggleUpdate}
        checked={internals?.lsva_validate_phone_and_language}
        label="Validate phone number and language"
      />
    </div>
  );
};

export default LSVASettings;
